import React from 'react';
import { formatNum } from '../../utils/dashboardFormatters';

const PRESET_LABELS = {
  today: 'today',
  yesterday: 'yesterday',
  last_7_days: 'last 7 days',
  last_14_days: 'last 14 days',
  last_28_days: 'last 28 days',
  last_30_days: 'last 30 days',
  this_month: 'this month',
  all_available: 'all available',
  all_time: 'all available',
  custom: 'selected period',
};

export default function DashboardTodayStrip({ today, dateFilter, loading }) {
  if (loading || !today) return null;
  const preset = dateFilter?.preset || 'all_time';
  const labelSuffix = PRESET_LABELS[preset] || 'today';

  const items = [
    { icon: 'fa-user-plus', label: `New users (${labelSuffix})`, value: today.newUsersToday },
    { icon: 'fa-bell', label: `Alerts (${labelSuffix})`, value: today.alertsToday },
    // Phase 2: { icon: 'fa-paper-plane', label: `Campaigns sent (${labelSuffix})`, value: today.campaignsToday },
  ];
  return (
    <div className="db-today-strip" aria-label="Activity snapshot">
      {items.map((item) => (
        <span key={item.label} className="db-today-pill">
          <i className={`fas ${item.icon}`} />
          {item.label}: <strong>{formatNum(item.value ?? 0)}</strong>
        </span>
      ))}
    </div>
  );
}
